import { useContext, useRef, useState } from "react";
import { ChevronDown, ArrowSquareUpright } from "@safetyculture/icons-react";
import { Button, Stack } from "@safetyculture/sc-web-ui";
import { SelectMenu, SelectOption } from "../../../components/util";
import { useFlag } from "../../../config/featureFlags";
import { hasAdminLevelPriviledge } from "../../../helpers";
import { AuthContext } from "../../../contexts";
import { theme } from "../../../styles";
import safetycultureService from "../../../services/safetyculture/safetyculture.service";
import styled from "styled-components";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";

type Props = {
  inspection_id?: string;
  navigateToSettingsTab: () => void;
};

export const ClaimActionMenu: React.FC<Props> = ({
  inspection_id,
  navigateToSettingsTab,
}) => {
  const [is_open, setIsOpen] = useState(false);
  const is_enabled = useFlag("portal.claims.createinspection");
  const { user } = useContext(AuthContext);
  const is_admin = hasAdminLevelPriviledge(user?.roles || []);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  const button_ref = useRef(null);
  const menu_ref = useRef(null);

  useOnClickOutside([button_ref, menu_ref], handleClickOutside);

  const handleViewInspection = () => {
    if (inspection_id) {
      window
        .open(
          safetycultureService.getiAuditorInspectionLink(inspection_id),
          "_blank",
        )
        ?.focus();
    }
    setIsOpen(false);
  };

  const handleLinkInspection = () => {
    navigateToSettingsTab();
    setIsOpen(false);
  };

  return is_enabled && is_admin ? (
    <Stack direction="column" align="flex-end">
      <Button
        variant="secondary"
        onClick={() => setIsOpen(prev => !prev)}
        endIcon={<ChevronDown />}
        ref={button_ref}
      >
        Actions
      </Button>

      {is_open && (
        <SelectMenu>
          <span ref={menu_ref}>
            {!!inspection_id && (
              <StyledSelectOption onClick={handleViewInspection} icon="eye">
                View inspection in SafetyCulture
                <StyledExternalLinkIcon
                  color={theme.color.surface.icon.weak.default}
                  size={18}
                />
              </StyledSelectOption>
            )}
            {!inspection_id && (
              <SelectOption icon="link" onClick={handleLinkInspection}>
                Link SafetyCulture inspection
              </SelectOption>
            )}
          </span>
        </SelectMenu>
      )}
    </Stack>
  ) : null;
};

const StyledSelectOption = styled(SelectOption)`
  align-items: center;
`;

const StyledExternalLinkIcon = styled(ArrowSquareUpright)`
  margin-left: 6px;
`;
